import { createSlice } from "@reduxjs/toolkit";
import {getUserProfile, googleSignin, signup, updateUserProfile, verifyOtp} from "../thunks/authThunks";

const authSlice = createSlice({
    name: "authSlice",
    initialState: {
        user: null
    },
    reducers:{
       clearUser: (state, action) => {
        state.user = null
       },
       setUser: (state, action) => {
        state.user = action.payload;
      },
    },
    extraReducers: (builder) => {
        builder
            .addCase(signup.fulfilled, (state, action) => {
                state.user = action.payload.data.userData
            })
            .addCase(updateUserProfile.fulfilled, (state, action) => {
                state.user = action.payload.data.userData
            })
            .addCase(getUserProfile.fulfilled, (state, action) => {
                state.user = action.payload.data.userData
            })
            .addCase(verifyOtp.fulfilled, (state, action) => {
                state.user = action.payload.data.userData
            })
            .addCase(googleSignin.fulfilled, (state, action) => {
                state.user = action.payload.data.userData
            })
    }
})

export const { clearUser, setUser } = authSlice.actions
export default authSlice.reducer
